import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login/views/Login.vue';
import GeneralDashboard from "./views/GeneralDashboard";
import Symbol from "./views/Asset/Symbol";
import TradingJournal from "./views/Journal/TradingJournal";
import JournalStats from "./views/Journal/views/JournalStats";
import JournalHome from "./views/Journal/views/JournalHome";
import Register from "./views/Register/Register";
import Welcome from "./views/Register/views/Welcome";
import Collapsed from './views/Register/views/Collapsed';
import Confirmation from "./components/Confirmation";
import Watchlist from './views/Watchlist/Watchlist';
import ResetPassword from './views/Login/Reset/ResetPassword';
import FinishResetPassword from './views/Login/Reset/FinishResetPassword';
import ConfirmedEmail from './views/Register/views/ConfirmedEmail';
import Profile from './views/User/Profile';
import SubscriptionPlans from './views/Subscription/SubscriptionPlans';
import SubscriptionPlansCollapsed from './views/Subscription/views/SubscriptionPlansCollapsed';
import SubscriptionPlansClub from './views/Subscription/views/club/SubscriptionPlansClub';
import ShareLinkIndex from './views/Community/views/ShareLinkIndex';
import ShareJournalHome from './views/Community/views/SharedJournalHome';
import SharedNotFound from './views/Community/views/SharedNotFound';
import PaymentEvent from './views/Subscription/PaymentEvent';
import ConnectTelegram from './views/User/views/ConnectTelegram';
//import Funding from './views/Funding/FundingIndex';
//import FundingSimulationIndex from './views/Funding/Simulation/FundingSimulationIndex';
//import FundingSimulationHome from './views/Funding/Simulation/views/TestHome';
import SimulationsIndex from './views/Funding/Simulation/views/SimulationsIndex.vue';
import Wizard from './views/Funding/Simulation/components/Wizard/Wizard.vue';
import FundingSimulationOnBoarding from './views/Funding/Simulation/views/TestOnBoarding';
import FundingSimulationSummary from './views/Funding/Simulation/views/TestOverview';
import FundingSimulationFeedback from './views/Funding/Simulation/views/TestFeedback';
import HalfOfFameIndex from './views/HallOfFame/HallOfFameIndex';
import HalfOfFameForex from './views/HallOfFame/views/HallOfFameForex';
import HalfOfFameFutures from './views/HallOfFame/views/HallOfFameFutures';
//Tournaments
import TournamentIndex from './views/Tournament/TournamentIndex';
import TournamentOverview from './views/Tournament/views/TournamentOverview';
//import TournamentEmbedRank from './views/Tournament/views/TournamentEmbedRank'
import TournamentsNewView from './views/Tournament/views/TournamentsNewView.vue';
import TournamentEmbedRegister from './views/Tournament/views/TournamentEmbedRegister.vue';
import TournamentLanding from './views/Tournament/views/TournamentLanding.vue';
import TournamentLandingAdmin from './views/Tournament/views/TournamentLandingAdmin.vue';
// import AnalysisIndex from './views/Analysis/AnalysisIndex';
import FeedbackIndex from './views/Feedback/FeedbackIndex';
import RankingIndex from './views/Ranking/RankingIndex';
import CommunityIndex from './views/Community/CommunityIndex';
import ClubIndex from './views/Community/views/ClubIndex';
import ClubSettings from './views/Community/components/ClubSettings';
import ClubEvents from './views/Community/components/ClubEvents';
import ClubChats from './views/Community/components/ClubChats'
import ClubRooms from './views/Community/components/ClubRooms';
import ClubMembers from './views/Community/components/ClubMembers';
import ClubChannels from './views/Community/components/ClubChannels';
import ClubTournaments from './views/Community/components/ClubTournaments';
import ClubLeague from './views/Community/components/ClubLeague';
import CalendarIndex from './views/Calendar/CalendarIndex';
import MentorIndex from './views/Mentor/MentorIndex';
import PlanIndex from './views/Plan/PlanIndex';
import SyncAuthorization from './views/User/views/SyncAuthorization';
import SyncAuthorizationRequest from './views/User/views/SyncAuthorizationRequest';
import EmbedIndex from "@/views/Embed/EmbedIndex.vue";
import OnboardIndex from "@/views/Onboard/OnboardIndex.vue";
import EmbedIntroduction from "@/views/Embed/views/EmbedIntroduction.vue";
import PasswordlessChecking from "@/views/Embed/views/PasswordlessChecking.vue";
import SSOEmbed from "@/views/Embed/views/SSOEmbed.vue";
import NewJournal from "./views/Journal/views/NewJournal.vue"
import TradeList from "./views/Journal/TradeList.vue"
import ConnectAccount from "./views/Metatrader/ConnectAccount.vue"
import ConnectExAccount from "./views/Exness/ConnectAccount.vue"

//New Simulation components
import NewFrontPage from './views/Funding/Simulation/views/NewFrontPage.vue';
import TestingComponents from './TestingComponents.vue';

//New Onboarding Register
//import OnBoarding from './views/Register/views/OnBoarding.vue';
import ClubDashboard from './views/Community/components/ClubDashboard';
import Integrations from "./views/Register/views/Integrations"; // Add this import
import PlatformSetup from "./views/Register/views/PlatformSetup"; // Add this import

// tournament settings component
import TournamentSettingsView from './views/Tournament/Settings/views/TournamentSettingsView.vue'
import father from './views/Tournament/components/father.vue';

// championship (SFB-1107)
import ChampionshipOverview from './views/Championship/views/ChampionshipOverview.vue';
import { CHAMPIONSHIP_ENABLED } from './config/feature-flags';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: {
                showChat: false
            },
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            component: ResetPassword
        },
        {
            path: '/account/reset/finish',
            name: 'finish-reset',
            component: FinishResetPassword
        },      
        {
            path: '/api/activate',
            name: 'confirmed-email',
            component: ConfirmedEmail,
            props: true
        },
        {
            path: '/profile/:referred?',
            name: 'profile',
            component: Profile,
            props: true
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: { hideNavigation: true },
            props: true,
            children: [
                {
                    path: 'integrations',
                    name: 'integrations',
                    component: Integrations,
                    props: true,
                },
                {
                    path: 'platform-setup',
                    name: 'platform-setup',
                    component: PlatformSetup,
                    props: true,
                },
                {
                    path: ':referred?',
                    name: 'welcome',
                    component: Welcome,
                    props: true,
                },
            ],
        },
        {
            path: '/register-collapsed',
            name: 'register-collapsed',
            component: Collapsed,
        },
        {
            path: '/confirmation',
            name: 'confirmation',
            component: Confirmation,
            props: true,
        },
        {
            path: '/onboard',
            name: 'onboard',
            component: OnboardIndex,
            props: true,
        },
                {
            path: '/basics',
            name: 'basicos',
            component: father,
            props: true,
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: GeneralDashboard,
            meta: {
                showChat: true
            }
        },
        {
            path: '/book',
            component: TradingJournal,
            children: [
                {
                    path: 'stats',
                    name: 'full-stats',
                    component: JournalStats,
                    props: true,
                },
                {
                    path: '',
                    name: 'book-home',
                    component: JournalHome,
                },
                {
                    path: 'shared',
                    name: 'shared-journal',
                    component: ShareJournalHome,
                },
            ],
        },
        {
            path: '/journal',
            name: "journal",
            component: NewJournal,
            children: [
                {
                    path: "data",
                    name: "data",
                    component: TradeList,
                    props: true
                },
                {
                    path: "stats",
                    name: "stats",
                    component: JournalStats,
                    props: true
                },
                {
                    path: "calendar",
                    name: "calendar",
                    component: CalendarIndex
                }
            ]
        },
        {
            path: '/asset-overview',
            name: 'asset-overview',
            component: Symbol,
            props: true
        },
        {
            path: '/watchlist',
            name: 'watchlist',
            component: Watchlist,
        },
        {
            path: '/subscription-plans',
            name: 'subscription-plans',
            component: SubscriptionPlans,
            props: true,
        },
        {
            path: '/subscription-plans-collapsed',
            name: 'subscription-plans-collapsed',
            component: SubscriptionPlansCollapsed,
            props: true,
        },
        {
            path: '/subscription-plans-club',
            name: 'subscription-plans-club',
            component: SubscriptionPlansClub,
        },
        {
            path: '/community',
            name: 'community',
            component: CommunityIndex,
        },
        {
            path: '/club',
            component: ClubIndex,
            props: true,
            children: [
                {
                    path: '',
                    name: 'club-dashboard',
                    component: ClubDashboard,
                },
                {
                    path: 'settings',
                    name: 'club-settings',
                    component: ClubSettings,
                },
                {
                    path: 'events',
                    name: 'club-events',
                    component: ClubEvents,
                },
                {
                    path: 'members',
                    name: 'club-members',
                    component: ClubMembers,
                },
                {
                    path: 'channels',
                    name: 'club-channels',
                    component: ClubChannels,
                },
                {
                    path: 'tournaments',
                    name: 'club-tournaments',
                    component: ClubTournaments,
                },
                {
                    path: 'league',
                    name: 'club-league',
                    component: ClubLeague,
                },
                {
                    path: 'chats',
                    name: 'club-chats',
                    component: ClubChats,
                },
                {
                    // Club Performance is hidden from the community admin view
                    // (SFB-1202); redirect so bookmarks/deep links don't expose it.
                    path: 'performance',
                    redirect: '/club',
                },
                {
                    path: 'rooms',
                    name: 'club-rooms',
                    component: ClubRooms,
                }
            ],
        },
        {
            path: '/share',
            name: 'share',
            component: ShareLinkIndex,
            children: [
                {
                    path: 'error',
                    name: 'shared-error',
                    component: SharedNotFound,
                }
            ],
        },
        // {
        //     path: '/calendar',
        //     name: 'calendar',
        //     component: CalendarIndex,
        // },
        {
            path: '/payment',
            name: 'payment',
            component: PaymentEvent,
        },
        {
            path: '/telegram',
            name: 'telegram',
            component: ConnectTelegram,
        },
        /*{
            path: '/funding',
            name: 'funding',
            component: Funding,
        },*/
        {
            path: '/funding-simulation',
            name: 'simulations-index',
            component: SimulationsIndex,
            children: [
                {
                    path: 'home',
                    name: 'funding-simulation-home',
                    component: NewFrontPage,
                    props: true
                },
                {
                    path: 'on-boarding',
                    name: 'funding-simulation-on-boarding',
                    component: FundingSimulationOnBoarding,
                    props: true,
                },
                {
                    path: 'summary',
                    name: 'funding-simulation-summary',
                    component: FundingSimulationSummary,
                    props: true,
                },
                {
                    path: 'feedback',
                    name: 'funding-simulation-feedback',
                    component: FundingSimulationFeedback,
                    props: true,
                },
                {

                    path: 'wizard',
                    name: 'funding-simulation-wizard',
                    component: Wizard,
                    props: true

                },
            ]
        },
        {
            path: '/hall-of-fame',
            name: 'hall-of-fame',
            component: HalfOfFameIndex,
            children: [
                {
                    path: 'forex',
                    name: 'hall-of-fame-forex',
                    component: HalfOfFameForex,
                },
                {
                    path: 'futures',
                    name: 'hall-of-fame-futures',
                    component: HalfOfFameFutures,
                }
            ],
        },
        {
            path: '/tournaments',
            component: TournamentIndex,
            children: [
                {
                    path: '',
                    name: 'tournament-home',
                    component: TournamentsNewView,
                },
                {
                    path: 'rank',
                    name: 'tournament-overview',
                    component: TournamentOverview,
                    props: true,
                },                {
                    path: 'embed-rank',
                    name: 'tournament-embed-rank',
                    component: TournamentOverview,
                    props: true,
                    meta: {
                        hideNavigation: true,
                        showChat: false
                    }
                },
                {
                    path: 'settings',
                    name: 'tournament-settings',
                    component: TournamentSettingsView,
                    props: true
                },
                ...(CHAMPIONSHIP_ENABLED ? [
                    {
                        // SFB-1107 — championship bracket view. Mounted under
                        // /tournaments so it shares TournamentIndex's RouterView.
                        path: 'championship',
                        name: 'championship-overview',
                        component: ChampionshipOverview,
                        props: true,
                    },
                ] : [
                    {
                        // This router has no catch-all; land direct URLs sanely
                        // when the championship flag is off.
                        path: 'championship',
                        redirect: '/tournaments',
                    },
                ]),
                {
                    path: 'embed-register',
                    name: 'tournament-embed-register',
                    component: TournamentEmbedRegister,
                    props: true,
                    meta: {
                        hideNavigation: true,
                        showChat: false
                    }
                },
                {
                    path: 'landing-demo',
                    name: 'tournament-landing',
                    component: TournamentLanding,
                    props: true,
                    meta: {
                        hideNavigation: true,
                        showChat: false
                    }
                },
                {
                    path: 'landing-admin',
                    name: 'tournament-landing-admin',
                    component: TournamentLandingAdmin,
                    props: true,
                    meta: {
                        hideNavigation: true,
                        showChat: false
                    }
                }
            ],
        },
        {
            path: '/mentor',
            name: 'mentor',
            component: MentorIndex,
        },
        {
            path: '/plan',
            name: 'plan',
            component: PlanIndex,
        },
        {
            path: '/equiti',
            name: 'ranking',
            component: RankingIndex,
        },
        // {
        //     path: '/analysis',
        //     name: 'analysis',
        //     component: AnalysisIndex,
        // },
        {
            path: '/feedback',
            name: 'feedback',
            component: FeedbackIndex,
        },
        {
            path: '/sync',
            name: 'sync-authorization',
            component: SyncAuthorization,
            children: [
                {
                    path: 'response',
                    name: 'sync-authorization-request',
                    component: SyncAuthorizationRequest,
                    props: true,
                }
            ]
        },
        {
            path: '/passwordless-checking',
            name: 'passwordless-checking',
            component: PasswordlessChecking,
            props: true,
        },
        {
            path: '/embed',
            name: 'embed',
            component: EmbedIndex,
            props: true,
            children: [
                {
                    path: 'introduction',
                    name: 'embed-introduction',
                    component: EmbedIntroduction,
                    props: true,
                },
                {
                    path: 'sso',
                    name: 'embed-sso',
                    component: SSOEmbed,
                    props: true,
                }
            ],
        },
        {
            path: '/connect-metatrader',
            name: 'connectmt',
            component: ConnectAccount,
        },
        {
            path: '/connect-exness',
            name: 'connectexness',
            component: ConnectExAccount,
        },
        {
            path: '/testing-components',
            name: 'testing-components',
            component: TestingComponents
        }
    ]
});

// Import store to access user state
import store from './store';

// Navigation guard to restrict demo user access
router.beforeEach((to, from, next) => {
    const user = store.state.user;
    const isDemoUser = user.id === 596 || user.email === 'demo@swiset.com';

    // List of restricted paths for demo user
    const restrictedPaths = [
        '/dashboard',
        '/watchlist',
        '/journal',
        '/mentor',
        '/plan',
        '/funding-simulation',
        '/hall-of-fame',
        '/subscription',
        '/sync-auth'
    ];

    // Check if demo user is trying to access a restricted route
    if (isDemoUser && restrictedPaths.some(path => to.path.startsWith(path))) {
        // Redirect to tournaments instead
        next('/tournaments');
    } else {
        // Allow navigation
        next();
    }
});

export default router;
